// src/routes/AuthRoutes.tsx
import AuthRoutes from "./AuthRoutes.tsx";
import MainRoutes from "./MainRoutes.tsx";

const AppRouter = [
  {
    path: "/",
    children: [AuthRoutes, MainRoutes],
  },
];

export default AppRouter;
